// client/plugins/ObsidianLinkPlugin/helper/parseLinkToText.ts
import { TextSelection } from "prosemirror-state";
import { findTextNodesWithPositions } from "./parseTextToLink.js";
var parseLinkToTextNode = ({ view }) => {
  let transaction = view.state.tr;
  if (transaction.selection.from !== transaction.selection.to)
    return false;
  const { state } = view;
  const pos = transaction.selection.from;
  const textNodesWithPositions = findTextNodesWithPositions(transaction.doc);
  const node = transaction.doc.nodeAt(pos - 1);
  const nodeWithPositions = textNodesWithPositions.find((n) => n.node === node);
  if (!node || !nodeWithPositions)
    return false;
  if (!node.marks)
    return false;
  if (!node.marks.some((mark) => mark.type.name === "link"))
    return false;
  const linkMark = node.marks.find((mark) => mark.type.name === "link");
  const text = node.text;
  const href = linkMark?.attrs.href;
  if (!linkMark)
    return false;
  if (!text)
    return false;
  const newNodeText = `[[${href}${href !== text && text ? `|${text}` : ""}]]`;
  const newNode = state.schema.text(newNodeText);
  transaction = transaction.replaceWith(
    nodeWithPositions.offset - 1,
    nodeWithPositions.offset + text.length - 1,
    newNode
  );
  if (view.state.selection.to <= nodeWithPositions.offset) {
    transaction = transaction.setSelection(TextSelection.create(transaction.doc, nodeWithPositions.offset - 1));
  } else {
    transaction = transaction.setSelection(
      TextSelection.create(transaction.doc, nodeWithPositions.offset + newNodeText.length - 1)
    );
  }
  view.dispatch(transaction);
  return true;
};
export {
  parseLinkToTextNode
};
